import { useQuery } from '@tanstack/react-query';
import { getOrdersApi } from '../utils/apis';
import { IGetOrdersParams } from '../schemas/apis/interface';
import { useUser } from './useUser';

export const useOrders = ({
  skip,
  limit,
  startDate,
  endDate,
  tenantName,
}: IGetOrdersParams) => {
  const { user } = useUser();
  const { data, isLoading, error, isError } = useQuery({
    queryKey: ['orders', startDate, endDate, skip, limit, user?._id],
    queryFn: () =>
      getOrdersApi({
        skip,
        limit,
        startDate,
        endDate,
        tenantName: user?.tenantName || tenantName,
        userId: user?._id || '',
      }),
    enabled: !!user,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    retry: 0,
  });

  return { data, isLoading, error, isError };
};
